const cardDeck = [
  '2_of_clubs',
  '2_of_diamonds',
  '2_of_hearts',
  '2_of_spades',
  '3_of_clubs',
  '3_of_diamonds',
  '3_of_hearts',
  '3_of_spades',
  '4_of_clubs',
  '4_of_diamonds',
  '4_of_hearts',
  '4_of_spades',
  '5_of_clubs',
  '5_of_diamonds',
  '5_of_hearts',
  '5_of_spades',
  '6_of_clubs',
  '6_of_diamonds',
  '6_of_hearts',
  '6_of_spades',
  '7_of_clubs',
  '7_of_diamonds',
  '7_of_hearts',
  '7_of_spades',
  '8_of_clubs',
  '8_of_diamonds',
  '8_of_hearts',
  '8_of_spades',
  '9_of_clubs',
  '9_of_diamonds',
  '9_of_hearts',
  '9_of_spades',
  '10_of_clubs',
  '10_of_diamonds',
  '10_of_hearts',
  '10_of_spades',
  'jack_of_clubs2',
  'jack_of_diamonds2',
  'jack_of_hearts2',
  'jack_of_spades2',
  'queen_of_clubs2',
  'queen_of_diamonds2',
  'queen_of_hearts2',
  'queen_of_spades2',
  'king_of_clubs2',
  'king_of_diamonds2',
  'king_of_hearts2',
  'king_of_spades2',
  'ace_of_clubs',
  'ace_of_diamonds',
  'ace_of_hearts',
  'ace_of_spades',
  'black_joker',
  'red_joker',
]

let cards

export function getGameDeck() {
  cards = [...cardDeck, ...cardDeck];
  cards = shuffle();
  return cards;
}

/* export function dealNineDown(players, gameDeck, discardPile) {
  let card
  const hands = Array.from({ length: players }, () =>
    Array.from({ length: 9 }, () => card)
  )
  for (let i = 0; i < 9; i++) {
    for (let j = 0; j < players; j++) {
      hands[j][i] = gameDeck.pop()
      hands[j][i].displayClass = 'hidden'
      hands[j][i].handIndex = i
    }
  }
  discardPile.push(gameDeck.pop())
  discardPile[0].displayClass = 'visible'
  return hands
}
 */
function getNineDownValues(item) {
  let value
  if (item.startsWith('ace')) {
    value = 1
  } else if (item.startsWith('2')) {
    value = 2
  } else if (item.startsWith('3')) {
    value = 3
  } else if (item.startsWith('4')) {
    value = 4
  } else if (item.startsWith('5')) {
    value = 5
  } else if (item.startsWith('6')) {
    value = 6
  } else if (item.startsWith('7')) {
    value = 7
  } else if (item.startsWith('8')) {
    value = 8
  } else if (item.startsWith('9')) {
    value = 9
  } else if (item.startsWith('10')) {
    value = 10
  } else if (item.startsWith('jack')) {
    value = 15
  } else if (item.startsWith('queen')) {
    value = 25
  } else if (item.startsWith('king')) {
    value = 0
  } else if (item.startsWith('red')) {
    value = -2
  } else if (item.startsWith('black')) {
    value = -2
  }
  return value
}

function shuffle() {
  let array = Array()
  let i = 0
  let j = 0
  let temp = null
  array = [...cards]

  for (i = array.length - 1; i > 0; i -= 1) {
    j = Math.floor(Math.random() * (i + 1))
    temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  const ary = array.map((c, index) => {
    const newValue = getNineDownValues(c)
    return {
      name: c,
      state: 'n',
      order: index,
      value: newValue,
      displayClass: 'hidden',
      handIndex: -1,
      zoom: false,
    }
  })

  return ary
}
